import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { DPI_CHARGES } from "@frameworks/web/redux/interfaces/Reports/iDpInterest";
class DpiChargesActions extends OnePlatformCommonActions {
    getDpInterestCharges(dpiCharges, type) {
        this.dispatch({
            type: DPI_CHARGES,
            payload: { dpiCharges },
            reducerName: type,
        });
    }
}
export default DpiChargesActions;
